{
  "install": {
    "aria": "Install the BidNova app",
    "title": "Install BidNova",
    "body": "Add BidNova to your home screen for instant bidding and live alerts.",
    "iosBody": "Tap Share, then “Add to Home Screen” to install BidNova for instant bidding and live alerts.",
    "iosHint": "Share → Add to Home Screen",
    "action": "Install app",
    "later": "Not now",
    "dismiss": "Dismiss install prompt"
  },
  "offline": {
    "title": "You're offline",
    "body": "Live bidding needs a connection. We'll reconnect automatically."
  }
}
